export const checkTextSafe = (request, data = {}) => {
  return request('/admin/v1/vehicle/safety/textScan', {
    method: 'POST',
    data,
  })
}

export const checkTextSafeHubble = (request, data = {}) => {
  return request('/dockingApi/v1/admin/invoker/antispamService_textListScanV2', {
    method: 'POST',
    data,
  })
}
